import Link from 'components/ui/AppLink';
import { Typography } from '@mui/material';
import React from 'react';

const DeskEmail = ({ email }: { email: string }) => {
    return (
        <div>
            <Typography sx={{ mt: 0, mb: 1 }} variant="h5">
                Contact the Desk
            </Typography>
            <Typography variant="body1">
                For general inquiries, please contact{' '}
                <Link ignoreRouter to={`mailto:${email}`}>
                    {email}
                </Link>
            </Typography>
        </div>
    );
};

export default DeskEmail;
